import { apiClient } from "./client";
import type {
  ActivityListResponse,
  ActivityLog,
  ActivityLogCreate,
} from "./types";

export async function getTimeline(
  slug: string,
  companyId: number,
  page = 1,
  pageSize = 50,
): Promise<ActivityListResponse> {
  const res = await apiClient.get<ActivityListResponse>(
    `/projects/${slug}/activity/${companyId}`,
    { params: { page, page_size: pageSize } },
  );
  return res.data;
}

export async function logAction(
  slug: string,
  companyId: number,
  payload: ActivityLogCreate,
): Promise<ActivityLog> {
  const res = await apiClient.post<ActivityLog>(
    `/projects/${slug}/activity/${companyId}`,
    payload,
  );
  return res.data;
}
